<template>
  <v-card
    v-if="revealBack"
    class="c-card--back c-card--reveal g-skinny-scrollbars transition-fast-in-fast-out pa-4"
  >
    <!-- header -->
    <v-list-item class="c-header pa-0 mb-2">
      <!-- title and subtitle -->
      <v-list-item-content class="c-titles align-self-start py-0">
        <v-card-title class="c-title pa-0 text-left">
          {{ item.title }}
        </v-card-title>
        <v-card-subtitle class="c-subtitle pa-0 text-subtitle-1">
          <i>{{ item.subtitle }}</i>
        </v-card-subtitle>
      </v-list-item-content>
      <!-- close button -->
      <v-btn
        class="align-self-start justify-end"
        icon
        large
        color="accent"
        @click="$emit('click:reveal', false)"
      >
        <v-icon> mdi-close </v-icon>
      </v-btn>
    </v-list-item>
    
    <!-- body -->
    <v-card-text class="text-left pa-0">
      <ClampedPortableText :blocks="summaryBlocks" />
    </v-card-text>
    
    <!-- parent document -->
    <v-card-actions class="justify-center">
      <v-btn v-if="hasParent" color="primary" large @click="$emit('view:parent')">
        {{ $t('content.action.viewParent') }}
      </v-btn>
    </v-card-actions>

    <!-- authors -->
    <v-card-text v-if="hasAuthors" class="pa-0">
      <v-subheader class="accent--text px-0">
        {{ $t('content.authors').toUpperCase() }} / {{ $t('content.advisors').toUpperCase() }} ({{
          item.authors.length
        }})
      </v-subheader>
      <v-list class="pa-0">
        <v-list-item
          v-for="author in item.authors"
          :key="author.lastName"
          class="mb-3 px-0"
        >
          <PersonBanner class="pl-0 py-0" :person="author" />
        </v-list-item>
      </v-list>
    </v-card-text>

    <!-- sponsor -->
    <v-card-text v-if="hasSponsor">
      <v-subheader class="pl-0">
        {{ $t('content.sponsor').toUpperCase() }}
      </v-subheader>
      <CompanyAvatar :sponsor="item.sponsor" />
    </v-card-text>
  </v-card>
</template>

<script>
import ClampedPortableText from '@/components/base/ClampedPortableText'
import CompanyAvatar from '@/components/base/CompanyAvatar'
import PersonBanner from '@/components/person/PersonBanner'

export default {
  name: 'ContentCardBack',

  components: {
    ClampedPortableText,
    CompanyAvatar,
    PersonBanner
  },

  model: {
    prop: 'reveal',
    event: 'click:reveal'
  },

  props: {
    reveal: {
      type: Boolean,
      required: true
    },

    item: {
      type: Object,
      required: true
    }
  },

  data: function () {
    return {
      revealBack: this.reveal
    }
  },

  computed: {
    summaryBlocks() {
      return this.item.summary
    },

    hasAuthors() {
      return this.item.authors?.length > 0 || false
    },

    hasParent() {
      return !!this.item.parent?.id
    },

    hasRelated() {
      return this.item.related?.length > 0
    },

    hasSponsor() {
      return !!this.item.sponsor
    },

    locale() {
      return this.$store.state.i18nStore.locale
    },

    defaultLocale() {
      return this.$store.state.i18nStore.defaultLocale
    }
  },

  watch: {
    reveal: {
      immediate: false, // initial value captured via data()
      handler: function (newVal, _oldVal) {
        this.revealBack = newVal
      }
    }
  },

  methods: {
    formatAuthorName(author, isFull = true) {
      const suffixes = isFull ? author.suffixes?.join(', ') : ''
      const fullName = [
        author.honorific || '',
        author.firstName || '',
        author.lastName || '',
        suffixes
      ].join(' ')
      return fullName
    },

    getAuthorInitials(author) {
      return author.firstName[0] + author.lastName[0]
    }
  }
}
</script>

<style lang="css" scoped>
.c-card--back {
  border-radius: 16px;
  height: 100%;
  overflow-y: auto;
}
.c-card--reveal {
  top: 0;
  left: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
}
.c-subtitle {
  line-height: 1.2;
  margin-top: 0px; /* normally -16px */
}
</style>
